/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Player_Audio_Track_LabelInputs */



/**
* | output |
* | --- |
* | "Track {index}" |
*
* @param {Player_Audio_Track_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_audio_track_label = /** @type {((inputs: Player_Audio_Track_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Audio_Track_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Piste ${i?.index}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Track ${i?.index}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Traccia ${i?.index}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Трек ${i?.index}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Pista ${i?.index}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`追踪${i?.index}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`トラック ${i?.index}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ट्रैक ${i?.index}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Faixa ${i?.index}`)
	return /** @type {LocalizedString} */ (`Track ${i?.index}`)
});